import { Modal } from 'antd'
import styled from 'styled-components'

/**
 * `styled(Modal)` porque as duas regras abaixo caem no `.ant-modal-content`, que o
 * antd renderiza por portal FORA da árvore deste componente — um container comum
 * não alcança. O `border-radius: 5px` sobrescreve o padrão do antd 5 (8px) e é
 * mantido para não mudar o visual que já estava em produção.
 */
export const ModalVisualizarMapa = styled(Modal)`
    .ant-modal-content {
        border-radius: 5px;
        padding: 0px;
    }

    div.VisualizarMapa__header {
        display: flex;
        justify-content: flex-start;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 15px;

        h3 {
            padding: 0;
            margin: 0;
        }
    }

    div.VisualizarMapa__infos {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 15px;
        padding-right: 15px;

        div {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            padding: 15px;

            label {
                font-size: 12px;
                font-weight: 500;
                color: #7b7b7b;
                padding: 0;
                margin: 0;
            }

            p {
                padding: 0;
                margin: 0;
                line-height: 1.1;
                font-size: 13px;
                font-weight: 600;
            }
        }
    }

    div.VisualizarMapa__mapa {
        display: flex;
        padding-left: 15px;
        padding-right: 15px;
        padding-bottom: 15px;
    }
`
